import MatchCalendarDefaultPageState from 'app/components/matchCalendar/MatchCalendarDefaultPageState';

type Action = {type: string; data?: any};

const MatchCalendarDefaultPageReducer = (
  state: MatchCalendarDefaultPageState,
  action: Action
): MatchCalendarDefaultPageState => {
  switch (action.type) {
    case 'MATCHCALENDAR_DEFAULT_UPDATE':
      return {
        ...state,
        date: action.data.date,
        filter: action.data.filter,
      };
    case 'MATCHCALENDAR_DEFAULT_DISTRICT_FETCHING':
      return {
        ...state,
        districtMatches: {...state.districtMatches, isFetching: true},
      };
    case 'MATCHCALENDAR_DEFAULT_PRO_FETCHING':
      return {
        ...state,
        proMatches: {...state.proMatches, isFetching: true},
      };
    case 'MATCHCALENDAR_DEFAULT_DISTRICT_UPDATE':
      return {
        ...state,
        districtMatches: {
          ...state.districtMatches,
          items: state.districtMatches.items.concat(action.data.items),
          nextUrl: action.data.nextUrl,
          isFetching: false,
        },
      };
    case 'MATCHCALENDAR_DEFAULT_PRO_UPDATE':
      return {
        ...state,
        proMatches: {
          ...state.proMatches,
          items: state.proMatches.items.concat(action.data.items),
          nextUrl: action.data.nextUrl,
          isFetching: false,
        },
      };
    case 'MATCHCALENDAR_DEFAULT_DISTRICT_ERROR':
      return {
        ...state,
        districtMatches: {...state.districtMatches, error: action.data, nextUrl: null, isFetching: false},
      };
    case 'MATCHCALENDAR_DEFAULT_PRO_ERROR':
      return {
        ...state,
        proMatches: {...state.proMatches, error: action.data, nextUrl: null, isFetching: false},
      };
    case 'MATCHCALENDAR_DEFAULT_OVERWRITE':
      return action.data;
    default:
      return state;
  }
};

export {MatchCalendarDefaultPageReducer};
